var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterMaterial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-459 261 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424D56",
    d: "M-428.4 277.8l-1.8-1.8 1.8-1.8c.4-.4.4-1 0-1.4l-2.1-2.1c-.4-.4-1-.4-1.4 0l-1.8 1.8-1.8-1.8c-.4-.4-1-.4-1.4 0l-1.8 1.8-1.8-1.8c-.4-.4-1-.4-1.4 0l-1.8 1.8-1.8-1.8c-.4-.4-1-.4-1.4 0l-2.1 2.1c-.4.4-.4 1 0 1.4l1.8 1.8-1.8 1.8c-.4.4-.4 1 0 1.4l1.8 1.8-1.8 1.8c-.4.4-.4 1 0 1.4l1.8 1.8-1.8 1.8c-.4.4-.4 1 0 1.4l2.1 2.1c.4.4 1 .4 1.4 0l1.8-1.8 1.8 1.8c.4.4 1 .4 1.4 0l1.8-1.8 1.8 1.8c.4.4 1 .4 1.4 0l1.8-1.8 1.8 1.8c.4.4 1 .4 1.4 0l2.1-2.1c.4-.4.4-1 0-1.4l-1.8-1.8 1.8-1.8c.4-.4.4-1 0-1.4l-1.8-1.8 1.8-1.8c.3-.3.3-1 0-1.4z"
  })));
}

export default SvgFilterMaterial;